<main id="main" class="main">


  <section class="section dashboard">

    <div class="row">

      <form class="plansform">
        <div class="row">
          <div class="form-group col-12 col-md-12 d-flex justify-content-between"
            style="background: #142a49!important; font-size:14px">
            <h6 class="admintitle">{{lang.Advisors}}&nbsp;&nbsp;<i class="bi bi-info-circle"></i></h6>
            <button class="addgroupadmininfoemp" (click)="addBrokerDetails()">+&nbsp;{{lang.Add_New}}</button>
          </div>

          <!-- <div class="row" class="filterByStatus">
            <div class="col-12 col-md-6 mt-2" style="position: absolute;">
              <label for="" style="font-size: 14px;font-family:'sans-serif';">{{lang.Filter_by_Status}}:&nbsp;</label>
            </div>
            <div class="col-md-6 p-0 mt-2" style="position: absolute;">
              <select name="" id="" class="form-select form-select-sm filterSelect" (change)="changeStatus($event)">
                <option value="all">{{lang.Select}}</option>
                <option value="true">{{lang.Active}}</option>
                <option value="false">{{lang.Inactive}}</option>
              </select>
            </div>
          </div> -->
          
          <!-- <div style="display: flex; justify-content: space-between;" class="w-100 mb-1">
            <div class="mt-2 mx-1">
              <span>Show</span>
                <select [(ngModel)]="itemsPerPage" class="mx-1" [ngModelOptions]="{standalone: true}">
                    <option value="{{10}}">10</option>
                    <option value="{{25}}">25</option>
                    <option value="{{50}}">50</option>
                    <option value="{{100}}">100</option>
                </select>
                <span>entries</span>
            </div>
            <input class="form-control" style="width: auto;" placeholder="Search here..." [(ngModel)]="filterValue" [ngModelOptions]="{standalone: true}" />
          </div> -->


            <div class="table-responsive mt-2">
              <table datatable [dtOptions]="dtOptions" id="dataTableId" [dtTrigger]="dtTrigger" class="page-link page-link active"
                class="table text-nowrap">
              <!-- <table
                class="table text-nowrap"> -->
                <thead>
                  <tr>
                    <!-- <th>S.no</th> -->

                    <th>{{lang.Name??'Name'}}</th>
                    <th>{{lang.Role??'Role'}}</th>
                    <th class="text-center">{{lang.List??'List'}}</th>
                    <th>{{lang.Email??'Email'}}</th>
                    <th>{{lang.Sales_Code??'Sales Code'}}</th>
                    <th>{{lang.Count??'Count'}}</th>
                    <th>{{lang.Corp??'Corp'}}</th>
                    <th>{{lang.Prov_Lic??'Prov Lic'}}</th>
                    <th>{{lang.E_O_Status??'E&O Status'}}</th>
                    <th>{{lang.Status??'Status'}}</th>
                    <th></th>

                    <!-- <th (click)="sortTable('name')" class="sorting">
                      {{lang.Name??'Name'}}
                      <i *ngIf="sortColumn === 'name'" 
                        [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'" 
                        class="ms-2"></i>
                    </th>
                    <th (click)="sortTable('brokerType')" class="sorting">
                      {{lang.Role??'Role'}}
                      <i *ngIf="sortColumn === 'brokerType'" 
                        [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'" 
                        class="ms-2"></i>
                    </th>
                    <th class="text-center">
                      {{lang.List??'List'}}
                    </th>
                    <th (click)="sortTable('email')" class="sorting">
                      {{lang.Email??'Email'}}
                      <i *ngIf="sortColumn === 'email'" 
                        [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'" 
                        class="ms-2"></i>
                    </th>
                    <th (click)="sortTable('salesTrackingCode')" class="sorting">
                      {{lang.Sales_Code??'Sales Code'}}
                      <i *ngIf="sortColumn === 'salesTrackingCode'" 
                        [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'" 
                        class="ms-2"></i>
                    </th>
                    <th (click)="sortTable('customersCount')" class="sorting">
                      {{lang.Count??'Count'}}
                      <i *ngIf="sortColumn === 'customersCount'" 
                        [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'" 
                        class="ms-2"></i>
                    </th>
                    <th (click)="sortTable('childsCount.corporate')" class="sorting">
                      {{lang.Corp??'Corp'}}
                      <i *ngIf="sortColumn === 'childsCount.corporate'" 
                        [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'" 
                        class="ms-2"></i>
                    </th>
                    <th (click)="sortTable('license.count')" class="sorting">
                      {{lang.Prov_Lic??'Prov Lic'}}
                      <i *ngIf="sortColumn === 'license.count'" 
                        [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'" 
                        class="ms-2"></i>
                    </th>
                    <th (click)="sortTable('EOIStatus')" class="sorting">
                      {{lang.E_O_Status??'E&O Status'}}
                      <i *ngIf="sortColumn === 'EOIStatus'" 
                        [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'" 
                        class="ms-2"></i>
                    </th>
                    <th (click)="sortTable('published')" class="sorting">
                      {{lang.Status??'Status'}}
                      <i *ngIf="sortColumn === 'published'" 
                        [class]="sortOrder === 'ASC' ? 'fa fa-arrow-up' : 'fa fa-arrow-down'" 
                        class="ms-2"></i>
                    </th>
                    <th></th> -->
                  </tr>
                </thead>
                <tbody *ngIf="!restLoader; else loadingState">
                  <tr *ngFor="let broker of brokerList; let i = index">
                  <!-- <tr *ngFor="let broker of filteredAndPaginatedAdvisors; let i = index"> -->
                    <!-- <td>{{i+1}}</td> -->
                    <td (click)="viewBrokerDetails(broker,i)" class="viewCorporate" style="cursor: pointer;">
                      <a><span class="my-auto" [title]="broker.name.length > 80 ? broker.name : ''">
                          {{ broker.name.length > 80 ? broker.name.substring(0, 80) + '...' : broker.name }}
                        </span></a>
                      <!-- {{ broker.salesTrackingCode ? '-' + broker.salesTrackingCode : '' }} -->
                    </td>
                    <td>{{broker.brokerType}}</td>
                    <td class="text-start ">
                      <button class="addgroupadmininfoemp"
                        (click)="viewsubBrokerList(broker.subBrokers,'viewAll',broker.name,broker.id)">{{lang.View}}</button>
                    </td>
                    <td>{{broker.email}}</td>
                    <td><span class="tooltiptext" data-bs-toggle="tooltip" data-bs-placement="top"
                        title="Desc:{{broker.salesTrackingCodeDescription}}"> {{broker.salesTrackingCode}}</span></td>
                    <td (click)="viewCountCustomers(broker.name,broker.id ,broker.subBrokerIds)"
                      style="color:rgb(56,76,159);cursor: pointer;" class="text-center text-center">
                      {{broker.customersCount}}</td>

                    <td class="text-center"><span
                        (click)="viewsubBrokerList(broker.subBrokers,'corporates',broker.name,broker.id)"
                        class="tooltiptext text-center viewCorporate" style="cursor: pointer;" data-bs-placement="top">
                        {{broker.childsCount.corporate}}</span>
                    </td>
                    <td class="text-center"><span class="tooltiptext text-center" data-bs-toggle="tooltip"
                        data-bs-placement="top"
                        title="Active:{{broker.license.active}},Expired:{{broker.license.expired}},AbovetoExpire:{{broker.license.aboveToExpire}}">
                        {{broker.license.count}}</span></td>
                    <td>
                      <button class="brokertablestatus text-center" *ngIf="broker.EOIStatus=='Expired'"
                        style="color:red">{{broker.EOIStatus}}</button>
                      <button class="brokertablestatus text-center" *ngIf="broker.EOIStatus=='Valid'"
                        style="color:green">{{broker.EOIStatus}}</button>
                      <button class="brokertablestatus text-center" *ngIf="broker.EOIStatus=='About to Expire'"
                        style="color:rgb(255, 136, 0)">{{broker.EOIStatus}}</button>
                      <button class="brokertablestatus text-center"
                        *ngIf="broker.EOIStatus!='Valid' &&  broker.EOIStatus!='Expired' &&  broker.EOIStatus!='About to Expire'">{{broker.EOIStatus}}</button>
                    </td>
                    <td>
                      <!-- <select class="form-control1" id="gender" [(ngModel)]="broker.status"
                        [ngModelOptions]="{standalone: true}" placeholder="Select"
                        (change)="brokerStatus(broker,brokerstatus.value,i)" #brokerstatus>

                        <option value="true"> Active </option>
                        <option value="false"> Inactive </option>

                      </select> -->

                      <span [style.color]="broker.published=='Active' ? 'green' : 'red'"
                        class="brokertablestatus text-center px-1">{{broker.published=='Active' ? 'Active':'Inactive'}}</span>
                    </td>
                    <td style="display:flex">
                      <!-- <a class="viewicon" title="View/Edit" data-toggle="tooltip" ><i class="fa fa-eye" (click)="viewBrokerDetails(broker,i)"></i></a>&nbsp; -->
                      <!-- <a *ngIf="role=='ADMINISTRATOR'" class="deleteicon" title="Delete" data-toggle="tooltip" ><i class="bi bi-trash-fill" (click)="deletebrokerDetails(broker,i)"></i></a>&nbsp; -->
                      <!-- fa fa-paper-plane -->
                      <a class="viewicon" title="Send Invite" data-toggle="tooltip"><i class="fa fa fa-send-o"
                          style="color: rgb(56,76,159); cursor: pointer; padding-top:8px"
                          (click)="invitationAdvisor(broker)"></i></a>&nbsp;
                    </td>
                  </tr>
                  <!-- <tr *ngIf="filteredAndPaginatedAdvisors.length==0">
                    <td [colSpan]="11" class="text-center">No Data Available</td>
                  </tr> -->
                </tbody>

                <ng-template #loadingState>
                  <tr *ngFor="let i of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10]" class="loader">
                    <td *ngFor="let j of [1, 2, 3, 4, 5, 6, 7, 8, 9, 10, 11]">
                      <div class="is-loading"><p></p></div>
                    </td>
                  </tr>
                </ng-template>
              </table>

            </div>

            <!-- <div class="pagination mb-5">
              <span class="mx-2"></span>
              <button class="btn btn-primary" (click)="previousPage()" [disabled]="currentPage === 1">Previous</button>
              <span>Page {{currentPage}} of {{totalPages()}}</span>
              <button class="btn btn-primary" (click)="nextPage()" [disabled]="currentPage === totalPages()">Next</button>
            </div> -->

          <!-- <button type="button" class="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="top" title="Tooltip on top"> Tooltip on top </button> <button type="button" class="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="right" title="Tooltip on right"> Tooltip on right </button> <button type="button" class="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="bottom" title="Tooltip on bottom"> Tooltip on bottom </button> <button type="button" class="btn btn-secondary" data-bs-toggle="tooltip" data-bs-placement="left" title="Tooltip on left"> Tooltip on left </button> -->

        </div>

      </form>

      <div class="row">
        <div class=" text-white text-left">
          <!-- <button class="btn btn-primary" id="backbuttonForm"
          type="button" (click)="gotoplansorwalletInfo()" style="float:left"><i aria-hidden="true" class="fa fa-long-arrow-left" ></i>&nbsp;&nbsp;Previous</button> -->

        </div>
        <div class=" text-white text-right">
          <!-- <button class="btn btn-primary" id="basicformSubmit" type="button" (click)="submitEmployeeInfoInfo()"> Save</button> -->
        </div>
      </div>



    </div>
  </section>
</main>



<div class="modal" id="subGroupList-modal" data-bs-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="myLargeModalLabel" aria-hidden="true">

  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header text-light " style="height:35px ;">
        <p class="modal-title" id="staticBackdropLabel">{{lang.Sub_Brokers_List}} - {{ selectedForView }} </p>
        <button type="button" *ngIf="disablesubBrokers" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closePopup()"></button>
      </div>
      <div class="model-body" style="margin-top: 20px;padding-right: 15px;
         padding-left: 15px; overflow-y: scroll;">

        <div class="row">
          <div class="table-responsive">
            <table id="DataTables_Table_1" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger1"
              class="table text-nowrap">
              <thead>
                <tr>
                  <!-- <th>S.no</th> -->
                  <th>{{lang.Name}}</th>
                  <th>{{lang.Type}}</th>
                  <th class="text-center">{{lang.Customers}}</th>
                  <th class="text-center"><span *ngIf="showSubbroker">{{lang.Sub_Brokers}}</span></th>

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let broker of customerslist; let i = index">
                  <!-- <td>{{i+1}}</td> -->
                  <td (click)="naviagtetoportal(broker)" style="cursor: pointer;" class="viewCorporate"><span><a>{{broker.name}}</a></span></td>
                  <td>{{broker.brokerType}}</td>


                  <td class="text-center">

                    <button [disabled]="checkCount(broker.customersCount) " (click)="viewBrokerCustomers(broker,i)"
                      style="cursor: pointer; background:white ;color: #1429A9;" class="viewicon border-0 "
                      title="Customers" data-toggle="tooltip">{{broker.customersCount}}</button>&nbsp;&nbsp;
                  </td>

                  <td class="text-center">
                    <button *ngIf="showSubbroker && broker.brokerType!='CORPORATE'"
                      [disabled]="checkCount(broker.subBrokerCount)"
                      style="cursor: pointer ;background: white;color: #1429A9;" class="border-0" title="Sub Brokers"
                      (click)="viewsupersubbrokerList(broker)">
                      {{broker.subBrokerCount}} </button>
                  </td>


                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>

      <div class="modal-footer">
        <button type="button" *ngIf="disablesubBrokers" class="btn btn-secondary" (click)="closePopup()"
          id="closeaddadmin" data-bs-dismiss="modal" #closemodel>
          {{lang.Close}}
        </button>
      </div>
    </div>
  </div>
</div>


<div class="modal modal-lg" id="supersubList-modal" data-bs-backdrop="static" tabindex="-1" role="dialog"
  aria-labelledby="myLargeModalLabel" aria-hidden="true" style="max-width: 100%;">

  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable" role="document">
    <div class="modal-content">
      <div class="modal-header text-light " style="height:35px ;">
        <p class="modal-title" id="staticBackdropLabel">{{lang.List_Members_of_Advisor}} - {{selectedSubBroker}}
        </p>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeSuperSubList()"></button>
      </div>
      <div class="model-body" style="margin-top: 20px;padding-right: 15px;
         padding-left: 15px; overflow-y: scroll;">

        <div class="row" *ngIf="!showListButtonDisabled">
          <div class="table-responsive">
            <table class="table text-nowrap">
              <thead>
                <tr>
                  <!-- <th>S.no</th> -->
                  <th>{{lang.Name}}</th>
                  <th>{{lang.Role}}</th>
                  <!-- <th>GIG</th> -->
                  <!-- <th></th> -->
                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let broker of subBrokers; let i = index">
                  <!-- <td>{{i+1}}</td> -->
                  <td>{{broker.name}}</td>
                  <td>{{broker.brokerType}}</td>


                  <!-- <td style="display:flex;cursor: pointer;">

                  </td> -->
                </tr>
                <!-- <small *ngIf="subBrokers.length==0">No Data Available</small> -->

              </tbody>
            </table>
          </div>
        </div>
        <div *ngIf="showListButtonDisabled" class="text-center">{{lang.No_data_available_in_table}}</div>
      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal"
          (click)="closeSuperSubList()">
          {{lang.Close}}
        </button>
      </div>
    </div>
  </div>
</div>



<!-- Modal -->
<div class=" modal modal-xl fade" id="customersList" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-hidden="true" style="max-width: 100%;">
  <div class="modal-dialog  modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header text-light " style="height:35px ;">
        <p class="modal-title" id="staticBackdropLabel">{{lang.Customers}}- {{selectedSubBroker}}</p>
        <button type="button" *ngIf="disableCustomers" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeCustomersList()"></button>
      </div>
      <div class="modal-body" style="margin-top: 20px;padding-right: 15px;
         padding-left: 15px;overflow-y: scroll;">
        <div class=" row">
          <div class="table-responsive">
            <div class="row" *ngIf="showdata">
              <div class="col-12 col-md-10 " style="font-size: 14px;">
                <p>{{lang.Name}}:&nbsp;<b>{{BrokerName | titlecase}}</b></p>
                <p>{{lang.Broker_Type}}:&nbsp;<b>{{brokerType}}</b></p>
                <p>{{lang.Broker_Advisor_Name}}:&nbsp;<b>{{ParentName | titlecase}}</b></p>

              </div>
              <div class="col-12 col-md-2 pt-4" *ngIf="customerList1.length>0">
                <label for="Corporation" class="Corporation">{{lang.Filter_by_Status}}</label>

                <select class="form-control" id="parentidrole" placeholder="Select" data-live-search="true"
                  (change)="filtercustomerstatus($event,status)">
                  <option value="" disabled>{{lang.Select}}</option>
                  <option value="All">{{lang.All}}</option>
                  <option *ngFor="let status of customerListStatus" [value]="status" [selected]="status== 'Active'">
                    {{status}}
                  </option>
                </select>
              </div>
            </div>

            <table id="DataTables_Table_2" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger2"
              class="table text-nowrap">
              <thead>
                <tr>
                  <!-- <th>S.no</th> -->
                  <th>{{lang.Type}}</th>
                  <th>{{lang.Name}}</th>
                  <th>{{lang.Gender}}</th>
                  <th>{{lang.Email}}</th>
                  <th>{{lang.DOB}}</th>
                  <th>{{lang.Phone}}</th>
                  <th>{{lang.Status}}</th>
                  <th class="text-left">{{lang.Plans}}</th>

                </tr>
              </thead>
              <!-- <i class="fa fa-info-circle" aria-hidden="true" data-bs-toggle="tooltip" data-bs-placement="right" title={{customer.contactInformations[0].line1}}></i> -->
              <tbody>
                <tr *ngFor="let customer of customerList1; let i = index">
                  <!-- <td>{{i+1}}</td> -->
                  <td><i *ngIf="customer.bulkPlanIncluded" class=""
                      style="font-size:14px;color:rgb(31, 31, 29);font-family: system-ui;font-weight: 600;"
                      title="Bulk/Group Plan Member">B</i>
                    <i *ngIf="customer.greenshieldMemberId || customer.greenshieldRegistrationStatus"
                      style="font-size:14px;color:green;font-family: system-ui;font-weight: 600;"
                      title="Greenshield Member">G</i>
                    <i *ngIf="customer.equitableCertificateId || customer.equitableRegistrationStatus"
                      style="font-size:14px;color:#2762b9;font-family: system-ui;font-weight: 600;"
                      title="Equitable Member">E</i>
                  </td>
                  <td (click)="gotomemberDetails(customer)" style="cursor: pointer;" class="viewCorporate"><a><span>{{customer.firstName}}&nbsp;{{customer.lastName}}</span></a></td>

                  <td>{{customer.gender}}</td>
                  <td>{{customer.email }}</td>
                  <td>{{customer.dateOfBirth | date: MM-dd-YYYY}}</td>
                  <td>{{customer.phoneNum}} </td>
                  <!-- <td>{{customer.contactInformations[0].line1}},{{customer.contactInformations[0].city}},{{customer.contactInformations[0].state}},{{customer.contactInformations[0].postalCode}}</td> -->
                  <td>
                    <span *ngIf="customer.status== 'All'" style="color:black">{{customer.status}}</span>
                    <span *ngIf="customer.status== 'Active'" style="color:green">{{customer.status}}</span>
                    <span *ngIf="customer.status== 'Cancelled'" style="color:red">{{customer.status}}</span>
                    <span *ngIf="customer.status== 'Draft'" style="color:orange">{{customer.status}}</span>
                  </td>
                  <td>
                    <button class="planStatusView"
                      (click)="viewcustomerPlansList(customer.customerPlans,customer.firstName,customer.lastName)">{{lang.View}}</button>

                  </td>

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" *ngIf="disableCustomers" class="btn btn-secondary" data-bs-dismiss="modal"
          (click)="closeCustomersList()">{{lang.Close}}</button>
      </div>
    </div>
  </div>
</div>


<div class=" modal modal-lg fade" id="countList" data-bs-backdrop="static" data-bs-keyboard="false" tabindex="-1"
  aria-hidden="true" style="max-width: 100%;">
  <div class="modal-dialog modal-lg modal-dialog-centered modal-dialog-scrollable">
    <div class="modal-content">
      <div class="modal-header text-light" style="height:35px;">
        <p class="modal-title" id="staticBackdropLabel">{{lang.Customers}} - {{selectedSubBroker}}</p>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeCountList()"></button>
      </div>
      <div class="modal-body" style="margin-top: 20px;padding-right: 15px;
         padding-left: 15px;overflow-y: scroll;">
        <div class=" row">

          <div class="table-responsive">
            <table id="DataTables_Table_4" datatable [dtOptions]="dtOptions2" [dtTrigger]="dtTrigger4"
              class="table text-nowrap">
              <thead>
                <tr>
                  <!-- <th>S.no</th> -->
                  <th>{{lang.Type}}</th>
                  <th>{{lang.Name}}</th>
                  <th>{{lang.Gender}}</th>
                  <th>{{lang.Email}}</th>
                  <th>{{lang.DOB}}</th>
                  <th>{{lang.Phone}}</th>
                  <th>{{lang.Status}}</th>
                  <!-- <th class="text-left">Plans</th> -->

                </tr>
              </thead>
              <tbody>
                <tr *ngFor="let customer of countCustomerList; let i = index">
                  <!-- <td>{{i+1}}</td> -->
                  <td><i *ngIf="customer.bulkPlanIncluded" class=""
                      style="font-size:14px;color:rgb(31, 31, 29);font-family: system-ui;font-weight: 600;"
                      title="Bulk/Group Plan Member">B</i>
                    <i *ngIf="customer.greenshieldMemberId || customer.greenshieldRegistrationStatus"
                      style="font-size:14px;color:green;font-family: system-ui;font-weight: 600;"
                      title="Greenshield Member">G</i>
                    <i *ngIf="customer.equitableCertificateId || customer.equitableRegistrationStatus"
                      style="font-size:14px;color:#2762b9;font-family: system-ui;font-weight: 600;"
                      title="Equitable Member">E</i>
                  </td>
                  <td (click)="gotomemberDetails(customer)" style="cursor: pointer;" class="viewCorporate"><span><a>{{customer.firstName}}&nbsp;{{customer.lastName}}</a></span></td>

                  <td>{{customer.gender}}</td>
                  <td>{{customer.email }}</td>
                  <td>{{customer.dateOfBirth |date:'MM-dd-YYYY'}}</td>
                  <td>{{customer.phoneNum}} </td>
                  <!-- <td>{{customer.contactInformations[0].line1}},{{customer.contactInformations[0].city}},{{customer.contactInformations[0].state}},{{customer.contactInformations[0].postalCode}}</td> -->
                  <td>
                    <span *ngIf="customer.status== 'All'" style="color:black">{{customer.status}}</span>
                    <span *ngIf="customer.status== 'Active'" style="color:green">{{customer.status}}</span>
                    <span *ngIf="customer.status== 'Cancelled'" style="color:red">{{customer.status}}</span>
                    <span *ngIf="customer.status== 'Draft'" style="color:orange">{{customer.status}}</span>
                    <span *ngIf="customer.status== 'Hold'" style="color:#1429a9">{{customer.status}}</span>
                  </td>
                  <!-- <td>
                    <button class="planStatusView"
                      (click)="viewcustomerPlansList(customer.customerPlans,customer.firstName,customer.lastName)">View</button>

                  </td> -->

                </tr>
              </tbody>
            </table>
          </div>
        </div>
      </div>
      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" data-bs-dismiss="modal"
          (click)="closeCountList()">{{lang.Close}}</button>
      </div>
    </div>
  </div>
</div>

<div class="modal modal-xl fade" id="customerPlansList-modal" data-bs-backdrop="static" data-bs-keyboard="false"
  tabindex="-1" aria-hidden="true" style="max-width: 100%;">

  <div class="modal-dialog modal-dialog-centered " role="document">
    <div class="modal-content">
      <div class="modal-header text-light " style="height:35px ;">
        <p class="modal-title" id="staticBackdropLabel">{{lang.Plan_List}}-{{selectedPlanCustomer}} </p>
        <button type="button" class="btn-close" data-bs-dismiss="modal" aria-label="Close"
          (click)="closeplansList()"></button>
      </div>
      <div class="model-body" style="margin-top: 20px;padding-right: 15px;
         padding-left: 15px;overflow-y: scroll;">


        <table id="DataTables_Table_3" datatable [dtOptions]="dtOptions" [dtTrigger]="dtTrigger3"
          class="table text-nowrap">
          <thead>
            <tr>
              <!-- <th>S.no</th> -->
              <th>{{lang.Name}}</th>
              <th>{{lang.Price}}</th>
              <!-- <th>Tax</th> -->
              <th>{{lang.Coverage}}</th>
              <!-- <th>{{lang.Signup_Date}}</th> -->
              <th>Enrollment Date</th>
              <th>{{lang.Enrolled_Date}}</th>
              <!-- <th>Status</th> -->

            </tr>
          </thead>
          <tbody>
            <tr *ngFor="let plan of customersplanslist; let i = index">
              <!-- <td>{{i+1}}</td> -->
              <td>{{plan.name}}</td>
              <td class="text-right">$ {{plan.price | number: "1.2-2"}}</td>
              <!-- <td class="text-right">{{plan.tax | number: "1.2-2"}}</td> -->
              <td>{{plan.coverage}}</td>
              <td>{{plan.signupDate | date:'MM-dd-YYYY'}}</td>
              <td>
                <span *ngIf="plan.enrolledDate !=null">{{plan.enrolledDate | date:'MM-dd-YYYY'}}</span>
                <span *ngIf="plan.enrolledDate ==null">---</span>
              </td>
              <!-- <td>{{plan.status}}</td> -->

            </tr>
          </tbody>
        </table>

      </div>

      <div class="modal-footer">
        <button type="button" class="btn btn-secondary" id="closeaddadmin" data-bs-dismiss="modal"
          (click)="closeplansList()" #closemodel>
          {{lang.Close}}
        </button>
      </div>
    </div>
  </div>
</div>

<app-confirmation-dialog   *ngIf="languageData"  [message]="message" [isAdvisor]="isAdvisor" [checkboxes]="checkboxesForMail"
  [ccCheckboxes]="ccCheckboxesForMail" [languageData]="languageData">
</app-confirmation-dialog>
